module.exports = __webpack_public_path__ + "img/42ae94f.jpg";